<div class="pin-code-container">
  <div class="main-content">
    <div class="pin-section">
      <div class="title">{{ params().digitCount }}-DIGIT PIN CODES</div>
      <div class="columns">
        @for (col of columns(); track col.position) {
          <div class="column">
            <div class="position-label">{{ col.label }}</div>

            <div class="digit-box">
              @if (col.selectedDigit !== null) {
                <span class="selected-digit">{{ col.selectedDigit }}</span>
              } @else {
                <span class="placeholder">&mdash;</span>
              }
            </div>

            <div class="digit-grid">
              @for (d of col.digits; track d) {
                <button
                  class="digit-cell"
                  [class.selected]="col.selectedDigit === d"
                  [disabled]="col.disabledDigits.has(d)"
                  (click)="selectDigit(col.position, d)"
                >
                  {{ d }}
                </button>
              }
            </div>

            <div class="choice-count">{{ col.choices }} choices</div>

            @if (col.restrictionLabel) {
              <div class="restriction-label">{{ col.restrictionLabel }}</div>
            }
          </div>
        }
      </div>
    </div>

    <div class="tree-section">
      <dojo-tree [params]="treeParams()" [matchingPaths]="selectedTreePath()" />
    </div>
  </div>
</div>
